import {blackListedCountryModal} from '../../generic-modal';

Hop.defineModule('modal-check-country', (root, params) => {
    const blackListedCountries = params.blackListedCountries || [];
    const popup = blackListedCountryModal();

    root.addEventListener('change', (e) => {
        const countrySelected = e.target.value;
        if (blackListedCountries.includes(countrySelected)) {
            popup.show(() => {});
        }
    });
});
